const IconBook = ({ size, color, ...props }) => (
    <svg width={size} height={size} viewBox="0 0 37 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M33.8241 3.21837V0H21.5404C21.1412 0 20.7458 0.078022 20.3769 0.22963C20.008 0.381238 19.6729 0.603466 19.3905 0.883602C19.1082 1.16374 18.8842 1.49631 18.7315 1.86232C18.5787 2.22834 18.5 2.62062 18.5 3.01679C18.5 2.21669 18.1797 1.44936 17.6095 0.883602C17.0393 0.317843 16.2659 0 15.4596 0H3.14881V3.24523H0V24H37V3.21837H33.8241ZM1.32047 4.56216H3.12847V20.3113H14.6808C15.3699 20.3115 16.0384 20.5445 16.5763 20.972C17.1141 21.3994 17.4893 21.9958 17.64 22.6629H1.32047V4.56216ZM35.6389 22.6629H19.3194C19.4701 21.9958 19.8453 21.3994 20.3831 20.972C20.921 20.5445 21.5895 20.3115 22.2786 20.3113H33.8241V4.5487H35.6321L35.6389 22.6629Z"
            fill={color}
        />
    </svg>
);

export default IconBook;
